export type MediaKind = "camera" | "microphone" | "screen";

/**
 * Konkord: the browser's device errors come in English ("Requested device
 * not found"); say what happened in Portuguese, like the rest of the app
 */
export function mediaError(e: unknown, device?: MediaKind): unknown {
  const name = (e as Error | undefined)?.name;
  const thing =
    device === "camera"
      ? "câmera"
      : device === "microphone"
        ? "microfone"
        : device === "screen"
          ? "tela"
          : "dispositivo";
  // câmera / tela are feminine, microfone / dispositivo masculine
  const fem = device === "camera" || device === "screen";
  const the = `${fem ? "A" : "O"} ${thing}`;
  const toThe = `${fem ? "à" : "ao"} ${thing}`;
  let message: string | undefined;
  switch (name) {
    case "NotFoundError":
    case "DevicesNotFoundError":
      message =
        device === "camera"
          ? "Nenhuma câmera encontrada. Conecte uma webcam e tente de novo."
          : device === "microphone"
            ? "Nenhum microfone encontrado. Conecte um e tente de novo."
            : device === "screen"
              ? "Nenhuma tela ou janela disponível para compartilhar."
              : "Dispositivo não encontrado.";
      break;
    case "NotReadableError":
    case "TrackStartError":
      message =
        device === "screen"
          ? "Não foi possível capturar a tela. Tente de novo ou escolha outra janela."
          : `${the} está ${fem ? "ocupada" : "ocupado"} por outro programa. Feche-o e tente de novo.`;
      break;
    case "OverconstrainedError":
    case "ConstraintNotSatisfiedError":
      message = `${the} ${fem ? "escolhida" : "escolhido"} não está mais disponível. Escolha ${fem ? "outra" : "outro"} nas configurações de voz.`;
      break;
    case "SecurityError":
      message = `O navegador bloqueou o acesso ${toThe}. Libere nas permissões do site.`;
      break;
    case "AbortError":
      message = `O acesso ${toThe} foi interrompido. Tente de novo.`;
      break;
    case "NotSupportedError":
      message = `Este navegador não permite usar ${the.toLowerCase()} aqui.`;
      break;
    // LiveKit's own error ("getDisplayMedia not supported") when the browser
    // has no such capture at all: the screen on the iPhone and the iPad
    // before iOS 27, and on Android
    case "DeviceUnsupportedError":
      message =
        device === "screen"
          ? "Este aparelho não transmite a tela. Transmita pelo computador."
          : `Este navegador não permite usar ${the.toLowerCase()} aqui.`;
      break;
  }
  return message ? new Error(message) : e;
}
